var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ma-0"},[_c('v-icon',{attrs:{"slot":"icon","color":"error","size":"19"},slot:"icon"},[_vm._v(" mdi-cancel ")]),_vm._v(" "+_vm._s(_vm.messageError)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }